const signupform = {


	/**
	 * Store the reef app for this component.
	 *
	 * @type {object}
	 */
	app: undefined,


	/**
	 * The id for the price plan to charge for.
	 *
	 * @type {string}
	 */
	price_plan: '',


	initialized: false,


	/**
	 * Initialize the component.
	 */
	init: function() {

		if ( signupform.initialized ) {
			return;
		}

		signupform.initialized = true;

		signupform.app = new Reef(
			null,
			{
				data: {},
				template: signupform.template,
				lagoon: true,
			}
		);

		// React to the relevant join buttons in the sidebar.
		document.getElementById( 'join-status' ).addEventListener( 'click', signupform.signupButton );

	},


	/**
	 * What happens when you click the signup button on the join page.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	signupButton: function( e ) {

		const user = members.app.data.member;

		// Reset the price id so we don't run the wrong one by accident.
		signupform.price_plan = '';

		// Get the payment product.
		const price = e.target.getAttribute( 'data-id' );

		if ( !price ) {
			return;
		} else {
			signupform.price_plan = price;
		}

		e.preventDefault();

		if ( !user ) {
			signupform.display( e.target );
			return;
		}

		signupform.newSubscription( user );

	},


	/**
	 * Load the payment page.
	 *
	 * @param {object} user The current user information.
	 * @return {void}
	 */
	newSubscription: function( user ) {

		console.log( 'user', user );

		// Make sure they don't have a subscription already.
		if ( user.subscriptionStatus ) {
			return;
		}

		// Make sure a subscription plan is set.
		if ( !signupform.price_plan ) {
			return;
		}

		// Redirect to the join page.
		const join_url = window.location.origin + '/join/';

		// https://twitter.com/UserbaseHQ/status/1261471331154931712/photo/2
		userbase.purchaseSubscription(
			{
				successUrl: join_url + '?success',
				cancelUrl: join_url + '?cancel',
				priceId: signupform.price_plan
			}
		)
			.then( () => { } )
			.catch( ( e ) => console.error( e ) );

	},


	/**
	 * Display the signup form.
	 *
	 * @return {void}
	 */
	display: function( target ) {

		let title = 'Join Brush Ninja';
		let description = target.innerHTML
			.replace( '&rarr;', '' )
			.replace( '→', '' )
			.trim();

		signupform.signup_modal = modal.showGeneral( title );
		signupform.signup_modal.innerHTML = signupform.template( description );

		signupform.signup_modal.addEventListener( 'click', signupform.click );
		signupform.signup_modal.addEventListener( 'change', signupform.blur );

	},


	/**
	 * Define the template for the component.
	 *
	 * @param {object} props The component properties.
	 * @return {string}
	 */
	template: function( description ) {

		const props = signupform.app.data;

		return `
		<p class="f4 f-fw900 fg-yellow">${description}</p>
		<form id="signup-form" method="POST">
			<label for="signup-username">Username</label>
			<input id="signup-username" name="signup-username" type="text" required autocomplete="username">

			<label for="signup-email">Email <small>Used for resetting passwords only.</small></label>
			<input id="signup-email" name="signup-email" type="email" required minLength="6" autocomplete="off">

			<label for="signup-password">Password</label>
			<input id="signup-password" name="signup-password" type="password" required placeholder="Password" autocomplete="new-password">

			<label class="m-b4">
				<input type="checkbox" name="terms-and-conditions-agreed" required />
				I have read and agree to the Brush Ninja <a href="/terms-and-conditions/" target="_blank">Terms and Conditions</a>
			</label>

			<div id="signup-error" class="p3 bg-red b-br1 f-fw600 m-b4 display-none"></div>

			<p class="p3 bg-green b-br1"><strong>Please note:</strong> Premium features will be unlocked once payment has completed.</p>

			<input type="submit" id="input-signup" value="Signup and pay" class="button">

			<p class="m-y3 f-fw500"><a href="/privacy-policy/" target="_blank">Privacy Policy &rarr;</a></p>
		</form>
		`;

	},


	/**
	 * Process the user sign up.
	 *
	 * @param {object} e The click event.
	 * @return {void}
	 */
	handleSignUp: function( e ) {

		const input_username = document.getElementById( 'signup-username' );
		const input_password = document.getElementById( 'signup-password' );
		const input_email = document.getElementById( 'signup-email' );

		// Get terms checkbox value.
		const terms = document.querySelector( 'input[name="terms-and-conditions-agreed"]' ).checked;

		if ( !terms ) {
			members.errorDisplay( 'Please agree to the terms and conditions.', 'signup-error' );
			return false;
		}

		const username = input_username.value;
		const password = input_password.value;
		const email = input_email.value;

		members.setUserLoading();

		let settings = { username, password, rememberMe: 'local' };
		// Only include email if it's set. This prevents the email being saved as 'undefined'.
		if ( email ) {
			settings.email = email;
		}

		userbase.signUp( settings )
			.then(
				( user ) => {
					modal.close();
					members.setUserLoggedIn( user );
					signupform.newSubscription( user );
				}
			)
			.catch(
				( e ) => {
					members.resetUserLogStatus();
					members.errorDisplay( e, 'signup-error' );
				}
			);

	},



	/**
	 * Click action for the component.
	 *
	 * @param {object} e Event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const id = target.id;

		if ( 'input-signup' === id ) {

			e.preventDefault();
			signupform.handleSignUp();

		}

	},


	/**
	 * Blur action for the component.
	 */
	blur: function( e ) {

		// console.log( 'blur', e );

		const blocked = [ 'csisd.org' ];

		const email = document.getElementById( 'signup-email' ).value;

		// If email contains text from blocked array, show error.
		if ( blocked.some( domain => email.includes( domain ) ) ) {
			document.getElementById( 'input-signup' ).setAttribute( 'disabled', 'disabled' );
			members.errorDisplay( 'Error with this email address.', 'signup-error' );
		} else {
			document.getElementById( 'input-signup' ).removeAttribute( 'disabled' );
		}

	},

};


